<script>
import { ref, toRef } from 'vue'

export default {
  props: {
    qty: {
      type: Number,
      required: true,
      default: 0
    },
    max: {
      type: Number,
      required: true,
      default: 3
    }
  },
  setup(props, { slots }) {
    const initQ = toRef(props, 'qty')
    const initM = toRef(props, 'max')
    const qty   = ref(initQ.value)
    const max   = ref(initM.value)

    const update = (action) => {
      if ( action === '+' ) {
        if ( qty.value < max.value ) {
          qty.value = qty.value + 1
        }
      } else {
        qty.value = ( qty.value > 1 ) ? ( qty.value - 1 ) : 0
      }
    }

    return () => slots.default({
      qty: qty.value,
      update
    })
  }
}
</script>